import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export type PubSubEvent = "ATUALIZAR_ALARMES" | "ATUALIZAR_USUARIOS" | "ATUALIZAR_USUARIO_LOGADO";

@Injectable({
  providedIn: 'root'
})
export class PubSubService {
  private eventData: Subject<PubSubEvent> = new Subject<PubSubEvent>();
  
  constructor() { }

  addEvent(event: PubSubEvent) {
    this.eventData.next(event);
  }

  getEvent() {
    return this.eventData.asObservable();
  }
}
